import { useState } from "react";
import { Search } from "lucide-react";
import { api, fileUrl, publicShopUrl } from "../../lib/api";
import { usePolling } from "../../hooks/usePolling";
import { PageHeader } from "../../components/PageHeader";
import { Input } from "../../components/ui/input";
import { Badge } from "../../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

const Pill = ({ ok, yes, no }) => (
  <Badge className={ok ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-50" : "bg-slate-100 text-slate-600 hover:bg-slate-100"}>{ok ? yes : no}</Badge>
);

export default function AdminShops() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  usePolling(async () => {
    const { data } = await api.get("/admin/shops");
    setItems(data);
  }, 5000);
  const filtered = (items || []).filter((s) => `${s.name} ${s.slug} ${s.owner_name}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <PageHeader title="Daftar Toko" subtitle="Semua toko affiliate di platform Jufi." />
      <div className="rounded-2xl border border-slate-200 bg-white fade-up">
        <div className="p-4 border-b border-slate-100">
          <div className="relative max-w-xs">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari toko..." className="pl-9" data-testid="shop-search-input" />
          </div>
        </div>
        <div className="md:hidden divide-y divide-slate-100" data-testid="shops-mobile-list">
          {filtered.map((s) => (
            <a key={s.shop_id} href={publicShopUrl(s.slug)} target="_blank" rel="noreferrer" className="p-4 flex items-center gap-3">
              <div className="h-10 w-10 shrink-0 overflow-hidden rounded-full bg-slate-100 grid place-items-center text-xs font-bold">
                {s.profile_photo ? <img src={fileUrl(s.profile_photo)} alt="" className="h-full w-full object-cover" /> : s.name[0]}
              </div>
              <div className="min-w-0 flex-1">
                <p className="font-semibold text-sm truncate">{s.name} <span className="font-mono text-xs font-normal text-slate-400">/{s.slug}</span></p>
                <p className="truncate text-xs text-slate-500">{s.owner_name} · {s.product_count} produk · {s.total_clicks} klik</p>
                <div className="mt-1 flex gap-1"><Pill ok={s.is_open} yes="Buka" no="Tutup" /><Pill ok={s.is_live && s.owner_active} yes="Live" no="Offline" /></div>
              </div>
            </a>
          ))}
        </div>
        <div className="hidden md:block overflow-x-auto">
          <Table data-testid="shops-table">
            <TableHeader><TableRow>
              <TableHead>Toko</TableHead><TableHead>Link</TableHead><TableHead>Pemilik</TableHead><TableHead>Kategori</TableHead>
              <TableHead>Buka</TableHead><TableHead>Publik</TableHead><TableHead className="text-right">Produk</TableHead><TableHead className="text-right">Klik</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {items && !filtered.length && <TableRow><TableCell colSpan={8} className="py-10 text-center text-sm text-slate-500">Belum ada toko.</TableCell></TableRow>}
              {filtered.map((s) => (
                <TableRow key={s.shop_id} data-testid={`shop-row-${s.slug}`}>
                  <TableCell>
                    <div className="flex items-center gap-3">
                      <div className="h-9 w-9 shrink-0 overflow-hidden rounded-full bg-slate-100 grid place-items-center text-xs font-bold">
                        {s.profile_photo ? <img src={fileUrl(s.profile_photo)} alt="" className="h-full w-full object-cover" /> : s.name[0]}
                      </div>
                      <span className="font-semibold">{s.name}</span>
                    </div>
                  </TableCell>
                  <TableCell><a href={publicShopUrl(s.slug)} target="_blank" rel="noreferrer" className="font-mono text-xs text-blue-600 hover:underline">/{s.slug}</a></TableCell>
                  <TableCell className="text-sm">{s.owner_name}<div className="text-xs text-slate-500">{s.owner_email}</div></TableCell>
                  <TableCell className="text-sm">{s.category || "-"}</TableCell>
                  <TableCell><Pill ok={s.is_open} yes="Buka" no="Tutup" /></TableCell>
                  <TableCell><Pill ok={s.is_live && s.owner_active} yes="Live" no={s.owner_active ? "Offline" : "Member nonaktif"} /></TableCell>
                  <TableCell className="text-right font-mono">{s.product_count}</TableCell>
                  <TableCell className="text-right font-mono">{s.total_clicks}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
